import React from 'react'
import PropTypes from 'prop-types'
import NumberWithText from '#components/a/NumberWithText'

export default function NumberRow(props) {
  const {numbers, modifier} = props
  return <div className={`number-row ${modifier}`}>{renderNumbers(numbers)}</div>
}

function renderNumbers(numbers) {
  const numbersWithText = numbers.map((number, index) => (
    <NumberWithText
      key={index.toString()}
      color={number.color}
      number={number.value}
      symbol={number.symbol}
      label={number.label}
    />
  ))
  return numbersWithText
}

NumberRow.propTypes = {
  numbers: PropTypes.array,
  modifier: PropTypes.string,
}
